<template>
  <div>
    <div class="organization_box">
      <div class="search-box">
        <search-com @search-btn="searchBtn" ref="searchCom"></search-com>
      </div>
      <div class="nav_box">
        <welfare-breadcrumb
          :itemBreadcrumb="itemBreadcrumb"
        ></welfare-breadcrumb>
      </div>
      <div class="city_box">
        <div class="city_now" @click="openCheckCity">
          <img
            class="city_dw"
            src="~/assets/img/health/icon_dw.png"
            alt="定位图标"
          />
          <span class="city_text"
            >当前城市：<b>{{ activeCity }}</b></span
          >
          <span class="city_btn"><i class="el-icon-sort"></i>切换城市</span>
        </div>
        <div class="city_list_box" v-if="showCityBox">
          <i class="el-icon-close" @click="showCityBox = false"></i>
          <el-input
            class="city_input"
            v-model="inputValue"
            placeholder="请输入城市名"
            clearable
            @input="selectInput()"
            @focus="searchFocus()"
          ></el-input>
          <div class="result_box" v-if="inputValue && inputValue.length">
            <div class="city_select_box" v-if="selectList && selectList.length">
              <div
                class="select_result"
                v-for="selectItem in selectList"
                :key="selectItem.cityCode"
                @click="clickInput(selectItem.cityName)"
              >
                {{ selectItem.cityName }}
              </div>
            </div>
            <div class="city_select_none" v-else>未查询到相关内容</div>
          </div>
          <div class="history_box" v-if="historyCities && historyCities.length">
            <p>历史城市：</p>
            <div class="history_list">
              <a
                class="history_item"
                @click="getCityName(historyItem.name)"
                v-for="(historyItem, index) in historyCities"
                :key="index"
                >{{ historyItem.name }}</a
              >
              <i class="el-icon-delete" @click="delHistory"></i>
            </div>
          </div>
          <city-box
            :isShow="showCityBox"
            @data-cityname="getCityName"
          ></city-box>
        </div>
      </div>
      <div class="choose_box">
        <div class="choose_item">
          <span class="choose_text">套餐类别</span>：
          <div class="list_box">
            <div class="list_item_box" @click="selectOption('MealType', '')">
              <span
                :class="
                  chooseList.MealType == ''
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >不限</span
              >
            </div>
            <div
              class="list_item_box"
              v-for="taocanItem in taocanList"
              :key="taocanItem.typeId"
              @click="selectOption('MealType', taocanItem.typeId)"
            >
              <span
                :class="
                  chooseList.MealType == taocanItem.typeId
                    ? 'list_item choose_active'
                    : 'list_item'
                "
              >
                {{ taocanItem.typeName }}
              </span>
            </div>
            <div class="list_more" v-if="taocanList.length > 9">
              <span
                >更多<i
                  :class="
                    taocanShowMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <div class="choose_item">
          <span class="choose_text">医院等级</span>：
          <div class="list_box">
            <div class="list_item_box" @click="selectOption('HospRank', '')">
              <span
                :class="
                  chooseList.HospRank == ''
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >不限</span
              >
            </div>
            <div
              class="list_item_box"
              v-for="(dengjiItem, dengjiIndex) in dengjiList"
              :key="dengjiIndex"
              @click="selectOption('HospRank', dengjiItem)"
            >
              <span
                :class="
                  chooseList.HospRank == dengjiItem
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >{{ dengjiItem }}</span
              >
            </div>
          </div>
        </div>
        <div class="choose_item">
          <span class="choose_text">区域</span>：
          <div class="list_box">
            <div class="list_item_box" @click="selectOption('AreaName', '')">
              <span
                :class="
                  chooseList.AreaName == ''
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >不限</span
              >
            </div>
            <div
              class="list_item_box"
              v-for="areaItem in areaList"
              :key="areaItem.areaCode"
              @click="selectOption('AreaName', areaItem.areaName)"
            >
              <span
                :class="
                  chooseList.AreaName == areaItem.areaName
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >{{ areaItem.areaName }}</span
              >
            </div>
            <div class="list_more" v-if="areaList.length > 9">
              <span
                >更多<i
                  :class="
                    areaShowMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
        <div class="choose_item">
          <span class="choose_text">机构服务</span>：
          <div class="list_box">
            <div class="list_item_box" @click="selectOption('Service', '')">
              <span
                :class="
                  chooseList.Service == ''
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >不限</span
              >
            </div>
            <div
              class="list_item_box"
              v-for="(serviceItem, serviceIndex) in serviceList"
              :key="serviceIndex"
              @click="selectOption('Service', serviceItem)"
            >
              <span
                :class="
                  chooseList.Service == serviceItem
                    ? 'list_item choose_active'
                    : 'list_item'
                "
                >{{ serviceItem }}</span
              >
            </div>
            <div class="list_more" v-if="serviceList.length > 9">
              <span
                >更多<i
                  :class="
                    serviceShowMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                  "
                ></i
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="list-box" v-if="tableList.length > 0">
        <div class="list-item" v-for="item in tableList" :key="item.hospId">
          <div class="left-box">
            <div class="img-box" @click="goOrgDtlBtn(item.hospId)">
              <img :src="item.hospImage" alt="" />
            </div>
            <div class="info-box">
              <div class="name" @click="goOrgDtlBtn(item.hospId)">
                {{ item.hospName }}
              </div>
              <div class="gray-box">
                <div class="gray-item">
                  <img
                    class="icon-box icon-box-hospital"
                    src="~/assets/img/health/icon-hospital.png"
                    alt=""
                  />
                  <div class="text">{{ item.hospRank }}</div>
                </div>
                <div class="gray-item">
                  <img
                    class="icon-box icon-box-address"
                    src="~/assets/img/health/icon-address.png"
                    alt=""
                  />
                  <div class="text">{{ item.hospAddress }}</div>
                </div>
                <div class="gray-item">
                  <img
                    class="icon-box icon-box-time"
                    src="~/assets/img/health/icon-time.png"
                    alt=""
                  />
                  <div class="text">{{ item.hospWorkTime }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-box">
            <div class="num-box">
              体检套餐：<span class="black-text">{{ item.mealCount }}个</span>
            </div>
            <div class="price-box">
              ¥ <span class="price-text">{{ item.minPrice }}</span> 起
            </div>
            <div class="btn-box" @click="goOrgDtlBtn(item.hospId)">
              查看详情
            </div>
          </div>
        </div>
        <div class="pagination-box" style="text-align:center;">
          <el-pagination
            @current-change="OnCurrentPageChanged"
            @size-change="handleSizeChange"
            :current-page="Params.PageIndex"
            :page-sizes="[10,20, 30, 40, 50, 60]"
            layout="prev, pager,next,sizes"
            :page-size="Params.Limit"
            background
            :total="Params.TotalCount"
          >
          </el-pagination>
        </div>
      </div>
      <div class="empty-box" v-else>
        <img src="~/assets/img/health/empty.png" alt="" />
      </div>
    </div>
    <Compare />
  </div>
</template>
<script>
import WelfareBreadcrumb from "@/components/welfareMallComp/WelfareBreadcrumb";
import SearchCom from "@/components/welfareMallComp/SearchCom";
import cityBox from "@/components/common/city";
import Compare from "@/components/healthCheckup/compare.vue";
import {
  getAreaList,
  getServiceList,
  getDataType,
  getHospitalList,
  getCityList,
  GetCurrentCity,
} from "network/welfareMall_api.js";
export default {
  name: "OrganizationList",
  components: {
    WelfareBreadcrumb,
    SearchCom,
    cityBox,
    Compare,
  },
  data() {
    return {
      itemBreadcrumb: [
        {
          name: '企业商城',
          to: '/welfareHome'
        },
        {
          name: "员工体检",
        },
      ],
      showCityBox: false,
      activeCity: "",
      historyCities: [],
      searchTimer: null,
      inputValue: "",
      selectList: [],
      chooseList: {
        CityName: "",
        AreaName: "",
        MealType: "",
        HospRank: "",
        Service: "",
      },
      taocanList: [], // 套餐类别
      dengjiList: ["公立三甲", "公立医院", "民营医院", "专业体检中心"],
      areaList: [], // 区域
      serviceList: [], // 机构服务
      Params: {
        PageIndex: 1,
        Limit: 10,
        TotalCount: 0,
      },
      tableList: [],
      sessionKey:'', // 用于标记页面加载的 key
    };
  },
  created() {
    this.historyCities = this.getSavedHistory();
    this.activeCity = this.getSavedCity();
    //console.log(this.activeCity)
    // 如果没有缓存的城市，获取定位城市
    if (!this.activeCity) {
      //获取当前城市
      this.getCurrentCity();
    } else {
      this.getCityCorrelation();
    }
  },
  mounted(){
    // 在页面加载时，设置 sessionKey
    sessionStorage.setItem(this.sessionKey, 'true');
    // 监听 beforeunload 事件
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    // 在组件销毁时移除事件监听
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    saveCitySelect() {
      // 更新历史记录
      const now = Date.now();
      const existingIndex = this.historyCities.findIndex(
        (city) => city.name === this.activeCity
      );
      if (existingIndex !== -1) {
        // 如果城市已存在，更新时间并重新排序
        this.historyCities[existingIndex].timestamp = now;
      } else {
        // 如果城市不存在，添加到历史记录
        this.historyCities.push({ name: this.activeCity, timestamp: now });
      }
      // 按时间降序排序
      this.historyCities.sort((a, b) => b.timestamp - a.timestamp);
      // 限制历史记录数量为7个
      if (this.historyCities.length > 7) {
        this.historyCities.splice(7);
      }
      // 保存到 localStorage
      localStorage.setItem("historyCities", JSON.stringify(this.historyCities));
      localStorage.setItem("selectedCity", this.activeCity);
    },
    // 从 localStorage 获取用户选择的城市
    getSavedCity() {
      return localStorage.getItem("selectedCity") || "";
    },
    // 从 localStorage 获取历史记录
    getSavedHistory() {
      const history = JSON.parse(localStorage.getItem("historyCities") || "[]");
      return history;
    },
    //清空历史记录
    delHistory() {
      this.historyCities = [];
      localStorage.removeItem("historyCities");
      localStorage.removeItem("selectedCity");
    },
    async getCurrentCity() {
      let res = await GetCurrentCity();
      //console.log(res);
      if (res.isSuccess) {
        this.activeCity = res.data;
        this.getCityCorrelation();
      }
    },
    getCityCorrelation() {
      this.saveCitySelect(); //保存定位城市
      this.getArea(this.activeCity);
      this.loadSelection();
      this.getTableList();
      this.getService();
      this.getType();
    },
    // 获取类型
    async getType() {
      let res = await getDataType(1);
      if (res.isSuccess) {
        this.taocanList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取服务
    async getService() {
      let res = await getServiceList();
      if (res.isSuccess) {
        this.serviceList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取区域
    async getArea(city) {
      let res = await getAreaList(city);
      console.log("获取区域", res);
      if (res.isSuccess) {
        this.areaList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    async getTableList() {
      let data = { ...this.chooseList, ...this.Params };
      data.CityName = this.activeCity;
      delete data.TotalCount;
      let res = await getHospitalList(data);
      if (res.isSuccess) {
        this.tableList = res.data;
        this.Params.TotalCount = res.count;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 点击查询 search
    searchBtn(val) {
      if (!val) {
        return this.$message.info("请输入商品或礼包名称");
      }
      document.cookie = "vueRouter=" + "/welfareSearchResult";
      this.$router.push({
        name: "WelfareSearchResult",
        params: {
          value: val,
        },
      });
    },
    // 切换城市
    openCheckCity() {
      this.showCityBox = true;
      this.inputValue = "";
      this.chooseList.AreaName = "";
      this.selectList = [];
    },
    debounce(fn, delay = 100) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(fn, delay);
    },
    // 搜索输入框focus事件
    searchFocus() {
      if (this.inputValue && this.inputValue.trim() !== "") {
        this.debounce(this.selectInput);
      }
    },
    // 搜索输入框input事件
    async selectInput() {
      let res = await getCityList(this.inputValue);
      if (res.isSuccess) {
        let cityList = res.data;
        const outputData = cityList.reduce((acc, item) => {
          // 将当前项的 cityList 合并到累积器数组中
          return acc.concat(
            item.cityList.map((city) => ({
              cityCode: city.cityCode,
              cityName: city.cityName,
            }))
          );
        }, []);
        this.selectList = outputData;
      }
    },
    clickInput(city) {
      this.activeCity = city;
      this.getCityName(city);
      this.getTableList();
    },
    //根据城市获取区域
    getCityName(data) {
      this.activeCity = data;
      this.getCityCorrelation();
      // this.getArea(data);
      // this.getTableList();
      this.showCityBox = false;
    },
    saveSelection(){
      // 将选择存储到 localStorage 中
      localStorage.setItem("orgaChooseList", JSON.stringify(this.chooseList));
    },
    loadSelection() {
      // 从 localStorage 中加载选择
      const savedSelection = localStorage.getItem("orgaChooseList");
      if (savedSelection) {
        this.chooseList = JSON.parse(savedSelection);
      }
    },
    handleBeforeUnload(event) {
     // 检查 sessionKey 是否存在
      if (sessionStorage.getItem(this.sessionKey)) {
        // 如果存在，说明是刷新页面，不清除 localStorage
        sessionStorage.removeItem(this.sessionKey); // 清除标记
      } else {
        // 如果不存在，说明是关闭页面，清除 localStorage
        localStorage.clear();
      }
    },
    //选择区域
    selectOption(type, value) {
      console.log(type,value)
      this.chooseList[type] = value;
      this.Params.PageIndex = 1;
      this.saveSelection();
      this.getTableList();
    },
    // 详情
    goOrgDtlBtn(hospId) {
      this.$router.push({
        name: "OrganizationDetails",
        query: {
          hospId: hospId,
        },
      });
    },
    //获取分页
    OnCurrentPageChanged(val) {
      this.Params.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.Params.Limit = val;
      this.getTableList();
    },
  },
};
</script>
<style lang="less" scoped>
.organization_box {
  width: 1200px;
  margin: 0 auto;
  .city_box {
    margin-top: 30px;
    .city_now {
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 50px;
      padding-left: 15px;
      background: #f9fbff;
      .city_dw {
        width: 15px;
        height: 18px;
        background-size: cover;
      }
      .city_text {
        margin-left: 8px;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        b {
          font-weight: bold;
          font-size: 17px;
          color: #ff9123;
        }
      }
      .city_btn {
        cursor: pointer;
        margin-left: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        border-left: 1px solid #999;
        i {
          margin-left: 10px;
          margin-right: 5px;
          transform: rotate(90deg);
        }
      }
    }
    .city_list_box {
      margin: 10px 0 0 15px;
      padding: 10px 20px 20px;
      position: absolute;
      z-index: 1;
      width: 433px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #dcdcdc;
      .el-icon-close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 16px;
      }
      .city_input {
        margin-top: 26px;
      }
      .result_box {
        position: absolute;
        background: #ffffff;
        box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.1);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #ececec;
        .city_select_box .select_result {
          font-size: 14px;
          color: #333;
          line-height: 26px;
          padding: 5px 20px;
          &:hover {
            cursor: pointer;
            color: #fff;
            background: #4c80fa;
          }
        }
        .city_select_none {
          font-size: 14px;
          color: #999;
          line-height: 26px;
          padding: 5px 20px;
        }
      }
      .history_box {
        margin-top: 10px;
        p {
          font-size: 16px;
          font-weight: 400;
          color: #333;
          line-height: 24px;
        }
        .history_list {
          margin-top: 5px;
          display: flex;
          align-items: center;
          height: 20px;
          a {
            cursor: pointer;
            font-size: 12px;
            font-weight: 400;
            color: #333;
            line-height: 20px;
            margin-right: 16px;
            &:hover {
              color: #4c80fa;
            }
          }
        }
        i {
          color: #eb3b3b;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .choose_box {
    margin-top: 30px;
    .choose_item {
      display: flex;
      margin-bottom: 10px;
      .choose_text {
        display: inline-block;
        width: 56px;
        height: 26px;
        line-height: 26px;
        font-weight: normal;
        font-size: 14px;
        color: #333333;
        text-align: justify;
        text-align-last: justify;
      }
      .list_box {
        margin-left: 10px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .list_item_box {
          cursor: pointer;
          margin-bottom: 10px;
          flex: 0 0 106px;
          display: inline-block;
          height: 26px;
          line-height: 24px;
        }
        .list_item {
          max-width: 104px;
          display: inline-block;
          font-size: 14px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:nth-child(1) {
            margin-left: 0;
          }
        }
        .choose_active {
          padding: 0 10px;
          font-size: 14px;
          color: #4c80fa;
          border: 1px solid #4c80fa;
          border-radius: 5px;
        }
        .list_more {
          position: absolute;
          right: 0;
          top: 0;
          cursor: pointer;
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
  // 列表
  .list-box {
    padding-bottom: 65px;
    .list-item {
      display: flex;
      justify-content: space-between;
      height: 155px;
      margin-bottom: 52px;
      .left-box {
        display: flex;
        .img-box {
          width: 216px;
          height: 155px;
          margin-right: 16px;
          border-radius: 10px 10px 10px 10px;
          overflow: hidden;
          img {
            cursor: pointer;
            width: 100%;
            height: 100%;
          }
        }
        .info-box {
          box-sizing: border-box;
          padding: 12px 0;
          .name {
            cursor: pointer;
            font-weight: 700;
            font-size: 16px;
            color: #333333;
            line-height: 21px;
            margin-bottom: 30px;
          }
          .gray-box {
            .gray-item {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #666666;
              line-height: 21px;
              margin-bottom: 10px;
              .icon-box {
                margin-right: 10px;
                object-fit: contain;
              }
              .icon-box-hospital {
                width: 13px;
                height: 13px;
              }
              .icon-box-address {
                width: 12px;
                height: 16px;
              }
              .icon-box-time {
                width: 14px;
                height: 14px;
              }
              &:last-child {
                cursor: pointer;
              }
            }
          }
        }
      }
      .right-box {
        padding: 12px 0;
        // text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .num-box {
          font-size: 16px;
          color: #999999;
          line-height: 21px;
          margin-bottom: 30px;
          .black-text {
            color: #333333;
          }
        }
        .price-box {
          font-size: 12px;
          color: #eb3b3b;
          line-height: 21px;
          margin-bottom: 10px;
          .price-text {
            font-size: 24px;
            font-weight: 700;
            padding: 0 2px;
          }
        }
        .btn-box {
          width: 86px;
          height: 32px;
          background: #0078fe;
          border-radius: 4px 4px 4px 4px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
  // 缺省图
  .empty-box {
    padding: 30px 0 65px;
    display: flex;
    justify-content: center;
    img {
      width: 270px;
      height: 270px;
    }
  }
}
</style>
